module.exports = __webpack_public_path__ + "img/6_staff-car-1.0a678762.gif";